import {
    FETCH_ESAT_PRODUCTS,
    CLEAN_ESAT_PRODUCTS,
    DELETE_ESAT_PRODUCT,
    DELETE_ESAT_PRODUCTS,
    PREPARE_ESAT_PRODUCT,
    SEND_ESAT_PRODUCT,
    REMOVE_ESAT_PRODUCT,
    SEND_ESAT_PRODUCTS,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const ESAT_PRODUCTS_DEFAULT_STATE = {};

const EsatProductsReducer = (state = ESAT_PRODUCTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_ESAT_PRODUCTS:
            return payload;

        case PREPARE_ESAT_PRODUCT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: 'prepare' };
                }

                return item;
            }) };

        case SEND_ESAT_PRODUCT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    if (payload.status === 'error') {
                        item = { ...item, error: payload.data.message };
                    } else if (payload.status === 'success') {
                        item = {
                            ...item,
                            references: { ...item.references, [payload.user_eshop_id]: payload.data.reference_id },
                            status: 'publish',
                            error: null,
                        };
                    }
                }

                return item;
            }) };

        case SEND_ESAT_PRODUCTS:
            return { ...state, items: _.map(state.items, item => {
                if (_.has(payload.data.reference_ids, item.id)) {
                    item = {
                        ...item,
                        references: { ...item.references, [payload.user_eshop_id]: payload.data.reference_ids[item.id] },
                        status: 'publish',
                        error: null,
                    };
                } else if (_.has(payload.data.errors, item.id)) {
                    item = { ...item, error: payload.data.errors[item.id] };
                }

                return item;
            }) };

        case REMOVE_ESAT_PRODUCT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = {
                        ...item,
                        references: _.omit(item.references, [payload.user_eshop_id]),
                        status: 'prepare',
                    };
                }

                return item;
            }) };

        case CLEAN_ESAT_PRODUCTS:
        case DELETE_ESAT_PRODUCT:
        case DELETE_ESAT_PRODUCTS:
            return ESAT_PRODUCTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default EsatProductsReducer;
